<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/integrallist/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
    >
      <el-form-item label="积分来源">
        <el-select v-model="formModel.awardSource">
          <el-option
            v-for="item in awardSource"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="代理商ID">
        <el-input v-model="formModel.userId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="商户号">
        <el-input v-model="formModel.merNo" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="formModel.integralType">
          <el-option
            v-for="item in integralType"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="结果">
        <el-select v-model="formModel.rankResult">
          <el-option
            v-for="item in rankResult"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="变动时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="awardSource"
        label="积分来源"
        :formatter="formatterTableawardSource"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="agentId"
        label="代理商ID"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="手机号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="realName"
        label="姓名"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="integralType"
        label="类型"
        :formatter="formatterTableintegralType"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="integral"
        label="积分"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="integralAfter"
        label="变动后积分"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merchantNo"
        label="商户号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merName"
        label="商户名称"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merPhone"
        label="商户手机号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merRealName"
        label="真实姓名"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="变动时间"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="rankResult"
        fixed="right"
        label="结果"
        :formatter="formatterTablerankResult"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import APPService from "service/APPService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "integrallist",
  components: {
    CommonTopForm,
    CommonTable,
  },
  data() {
    return {
      awardSource: [
        {
          code: "",
          name: "全部",
        },
      ],
      integralType: [],
      rankResult: [
        {
          code: "",
          name: "全部",
        },
        {
          code: "1",
          name: "成功",
        },
        {
          code: "0",
          name: "失败",
        },
      ],
      formModel: {
        awardSource: "",
        integralType: "",
        rankResult: "",
        userId: "",
        merNo: "",
        time: "",
      },
      tableData: [],
      submitService: APPService.integrallistList,
      params: {},
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      const params = {
        awardSource: this.formModel.awardSource,
        integralType: this.formModel.integralType,
        rankResult: this.formModel.rankResult,
        userId: this.formModel.userId,
        merNo: this.formModel.merNo,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.formModel.time.length) {
        params.startTime = this.formModel.time[0];
        params.endTime = this.formModel.time[1];
      }
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {
        awardSource: "",
        integralType: "2",
        rankResult: "",
        time: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
      this.getawardSource();
      this.getintegralType();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    getawardSource() {
      this.doLoad(
        APPService.integralSource,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.awardSource = [...this.awardSource, ...res.contents];
          });
        },
        "信息获取失败"
      );
    },
    getintegralType() {
      this.doLoad(
        APPService.integralType,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.integralType = res.contents;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    formatterTableawardSource(row, column, cellValue, index) {
      let value = "";
      this.awardSource.forEach((item) => {
        if (item.code == cellValue) {
          value = item.name;
        }
      });
      return value ? value : "--";
    },
    formatterTableintegralType(row, column, cellValue, index) {
      let value = "";
      this.integralType.forEach((item) => {
        if (item.code == cellValue) {
          value = item.name;
        }
      });
      return value ? value : "--";
    },
    formatterTablerankResult(row, column, cellValue, index) {
      let value = "";
      this.rankResult.forEach((item) => {
        if (item.code == cellValue) {
          value = item.name;
        }
      });
      return value ? value : "--";
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/RankIng/IntegralList.vue